<template>
    <section id="listing">
        <b-row>
            <b-col>
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text>
                      <v-icon icon="search"/>
                    </b-input-group-text>
                  </template>

                    <b-input v-model="filter"/>
                </b-input-group>
            </b-col>
        </b-row>

        <b-table
            striped
            hover
            responsive
            :items="campuses"
            :fields="fields"
            :filter="filter"
            sort-by="title"
            ref="table">
            <template #cell(title)="{item}">
                <b-link :href="'campuses/' + item.id + '/edit'"
                        v-text="item.name"></b-link>
            </template>
        </b-table>
    </section>
</template>

<script>
    import axios from 'axios'
    import moment from '../../moment'
    import qs from 'qs'

    export default {
        props: ['campuses'],
        data()
        {
            return {
                filter: '',
                fields: [
                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true
                    }
                ],
                meta: {}
            }
        }
    }
</script>
